export type UploadAssetRequestManagerBaseEvent =
	typeof UPLOAD_ASSET_REQUEST_MANAGER_BASE_EVENT;

export const UPLOAD_ASSET_REQUEST_MANAGER_BASE_EVENT = `upload:asset:request:manager`;

export const UPLOAD_ASSET_REQUEST_MANAGER_EVENT = <const>{
	VIEW: `${UPLOAD_ASSET_REQUEST_MANAGER_BASE_EVENT}:view`,
};
